<template>
  <div>
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ getTitle }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <router-link :to="routeToCreation">
              <a
                class="button is-addOrEdit"
                :class="{'button-access-no-permission': !checkPermissions(permCatalogue.maj)}">
                {{ $t('listeProduitsModulePresse.button.newProduct') }}
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="criteresRecherche" class="tableWithPerPageSelection">
      <div class="level mgt-20px">
        <div class="level-left">
          <div class="columns">
            <div class="column is-narrow">
              <selecteur-action
                :options="[]"
                :placeholder='$t("general.placeHolder.groupedAction")'
                :titleButton="'general.button.apply'"
                :elementsSelectionnes="produitSelectionne"
              />
            </div>
            <form
              @submit.prevent="recherche()"
              class="column is-5 pdr-0 pdl-0">
              <b-input
                v-model="criteresRecherche.auto"
                :placeholder="$t('general.autocomplete.search')"
                type="search" icon="magnify">
              </b-input>
            </form>
            <div class="column is-narrow">
              <button class="button" @click="setShowFiltre">
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">
                  {{$t('general.button.filtre')}}
                  <label
                    :class="nombreCritere > 0 ? '' : 'is-invisible'"
                    class="has-text-weight-bold">
                    ({{ nombreCritere }})
                  </label>
                </span>
              </button>
              <span
                @click="reinitialiser()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
                <b-icon icon="close-circle" type="is-danger"></b-icon>
              </span>
            </div>
          </div>
        </div>
        <div class="columns level-right">
          <div class="column is-narrow">
            <exportExcelButton
              :perm="permCatalogue.exporter"
              :query="exportExcelQuery"/>
          </div>
          <parametrage-table
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
      </div>
      <v-server-table
        url=""
        :columns="columns"
        :options="options"
        @loaded="finLoading"
        @loading="debutLoading"
        :ref="referenceTable"
        v-if="startArrayRendering && mountedLoadingEnd">
        <template slot='afterTable'>
          <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[referenceTable].setLimit($event)"/>
        </template>
        <div slot="selected" slot-scope="props" class="has-text-centered">
          <b-checkbox
            v-model="props.row.selected"
            :value="props.row"
            @input="selectionProduits()">
          </b-checkbox>
        </div>
        <div slot="reference" slot-scope="props">
          <router-link
            :to="{
              name: getLibelleAndRoutesForProduct(props.row).routeDetail,
              params: {id: props.row.id}
            }"
            :class="{'text-access-no-permission': !checkPermissions(permCatalogue.lecture)}"
            class="lien">
            {{ props.row.reference }}
          </router-link>
        </div>
        <div slot="type" slot-scope="props">
          {{ $t(getLibelleAndRoutesForProduct(props.row).libelle) }}
        </div>
        <div slot="typeSupport" slot-scope="props">
          <span v-if="props.row.produit.typeProduitId">
            {{ props.row.produit.typeProduit.libelle }}
          </span>
        </div>
        <div slot="marche" slot-scope="props">
          <router-link-blank
            v-if="props.row.marcheId"
            :message="props.row.marche.libelle"
            :to="{
              name: 'c.presse.marche',
              params: {id: props.row.marcheId}
            }"
            :class="{'text-access-no-permission': !checkPermissions(perms.marche.lecture)}"
            class="lien">
          </router-link-blank>
        </div>
        <div slot="fournisseur" slot-scope="props">
          <router-link-blank
            v-if="getFournisseurs(props.row.marche).length === 1"
            :message="getFournisseurs(props.row.marche)[0].nomCommercial"
            :to="{
              name: 'c.presse.fournisseur_support',
              params: {id: getFournisseurs(props.row.marche)[0].id}
            }"
            :class="{'text-access-no-permission': !checkPermissions(perms.marche.lecture)}"
            class="lien">
          </router-link-blank>
          <router-link-blank
            v-else-if="props.row.marcheId"
            :message="getFournisseurs(props.row.marche).map(f => f.nomCommercial).join(', ')"
            :to="{
              name: 'c.presse.marche',
              params: {id: props.row.marcheId, activeTab: 'fournisseur'}
            }"
            :class="{'text-access-no-permission': !checkPermissions(perms.marche.lecture)}"
            class="lien">
          </router-link-blank>
        </div>
        <div slot="dateDebut" slot-scope="props">
          {{ getDate(props.row.produit.dateDebut) }}
        </div>
        <div slot="dateFin" slot-scope="props">
          {{ getDate(props.row.produit.dateFin) }}
        </div>
        <div slot="societe" slot-scope="props">
          {{ getLibelleSociete(props.row.supportCommercial.societeId) }}
        </div>
        <div slot="regroupementProduit" slot-scope="props">
          <span v-if="props.row.regroupementProduit">
            <router-link-blank
              :to="{ name: 'c.bodac.catalogue-detailRegroupementProduit',
                params: { id: props.row.regroupementProduit.id }}"
              :message="props.row.regroupementProduit.code"/>
          </span>
        </div>
        <div slot="actif" slot-scope="props">
          {{ getLibelleActif(props.row.actif) }}
        </div>
        <div slot="agence" slot-scope="props">
          {{ getAgenceLibelle(props.row.agenceId) }}
        </div>
        <div slot="edit" slot-scope="props">
          <router-link
            :to="{
              name: getLibelleAndRoutesForProduct(props.row).routeModif,
              params: { produitId: props.row.id },
            }"
            :class="[
              {'button-access-no-permission': !checkPermissions(permCatalogue.maj)
                || isNotModifiableIntoHolding(props.row)},
              {'pointer-events-none': isNotModifiableIntoHolding(props.row)}
            ]">
            <b-icon
              icon="pencil-box-outline" type="is-success"
              :class="{'text-access-no-permission': !checkPermissions(permCatalogue.maj)
                || isNotModifiableIntoHolding(props.row) }">
            </b-icon>
          </router-link>
        </div>
        <div slot="archiver" slot-scope="props">
          <div
            @click="checkPermissions(permCatalogue.supprimer)
              ? showPopUpArchivage(props.row)
              : showPopUpPermission()"
            class="is-cursor-pointer"
            :class="{'disabled': isNotModifiableIntoHolding(props.row)}">
            <b-icon
              type="is-default" :icon="props.row.actif ? 'archive' : 'archive-arrow-up'"
              :class="{'text-access-no-permission': !checkPermissions(permCatalogue.supprimer)
                || isNotModifiableIntoHolding(props.row)}">
            </b-icon>
          </div>
        </div>
        <div slot="delete" slot-scope="props">
          <div
            @click="checkPermissions(permCatalogue.supprimer)
              ? inProgress()
              : showPopUpPermission()"
            :class="!isNotModifiableIntoHolding(props.row)
              ? 'is-cursor-pointer' : 'pointer-events-none'">
            <b-icon
              type="is-danger" icon="delete-forever"
              :class="{'text-access-no-permission': !checkPermissions(permCatalogue.supprimer)
                || isNotModifiableIntoHolding(props.row) }">
            </b-icon>
          </div>
        </div>
      </v-server-table>
      <transition
        name="custom-classes-transition"
        enter-active-class="animate__animated animate__slideInRight"
        leave-active-class="animate__animated animate__slideOutRight"
        :duration="10">
        <div class="componentBrief" v-show="showFiltre === true">
          <filtre-liste-produits-module-presse
            ref="filtreListeProduit"
            @toggleFiltre="setShowFiltre"
            @recherche="makeRechercheFilter()"
          />
        </div>
      </transition>
      <b-modal
        v-model="popUpArchivage"
        @close="produitToArchive = null"
        class="modal"
        has-modal-card>
        <pop-up-prevention
          v-if ="produitToArchive"
          :messHeader="$t(`${baseTradArchiveComputed(produitToArchive.actif)}.title`)"
          :cancel="$t(`${baseTradArchiveComputed(produitToArchive.actif)}.no`)"
          :validate="$t(`${baseTradArchiveComputed(produitToArchive.actif)}.yes`)"
          @no="popUpArchivage = false"
          @yes="archiverProduit(produitToArchive.actif)"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { archiver as archiverProduitSponsoring } from '@/api/produit/produitSponsoring';
import { archiver as archiverProduitAutre } from '@/api/produit/produitAutre';
import { archiver as archiverProduitSalon } from '@/api/produit/produitSalon';
import { archiver as archiverProduitPresse } from '@/api/produit/produitPresse';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import inProgress from '@/services/general/inProgress';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatDate from '@/services/general/formatDate';
import { columnsSplice } from '@/services/general/columns';
import { getIdSocieteHolding, siteHasHolding } from '@/services/general/holding';
import subscribeMutation from '@/services/store/subscribeMutation';
import AppBreadcrumb from '@/components/general/breadcrumb';
import SelecteurAction from '@/components/general/selecteurAction';
import PopUpPrevention from '@/components/general/popUpPrevention';
import TableItemsInView from '@/components/general/TableItemsInView';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import FiltreListeProduitsModulePresse from '@/components/catalogue/filtre/filtreListeProduitsModulePresse';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import * as tableConfig from '@/configuration/clientTableConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { MARCHE } from '@/configuration/achat/permissionsConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import produitSponsoringTransform from '@/services/presse/sponsoring/produitSponsoringServerTableDataTransformer';
import parametrageTable from '@/components/general/parametrageTable';
import {
  REFERENCE_TABLE_PRODUIT_PRESSE,
  REFERENCE_TABLE_PRODUIT_SALON,
  REFERENCE_TABLE_PRODUIT_SPONSORING,
  REFERENCE_TABLE_PRODUIT_AUTRE,
} from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const ProduitsPresse = createNamespacedHelpers('produitsPresse');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'LProduitsModulePresse',
  components: {
    AppBreadcrumb,
    SelecteurAction,
    PopUpPrevention,
    TableItemsInView,
    RouterLinkBlank,
    FiltreListeProduitsModulePresse,
    parametrageTable,
    exportExcelButton,
  },
  data() {
    return {
      produitSelectionne: false,
      selectAllValue: false,
      showFiltre: false,
      produitToArchive: null,
      popUpArchivage: false,
      loadingComponent: null,
      permCatalogue: CATALOGUE,
      unsubscribeValue: null,
      perms: {
        marche: MARCHE,
      },
      resultPerPage: tableConfig.RESULTS_PER_PAGE,
      startArrayRendering: false,
      mountedLoadingEnd: false,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...ProduitsPresse.mapGetters({
      produits: 'items',
      totalProduits: 'total',
      criteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      agenceActive: 'agenceActive',
      lockMenu: 'lockMenu',
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    getTitle() {
      return this.$t(`listeProduitsModulePresse.title.${this.$route.params.typeProduit}`);
    },
    breadcrumb() {
      const { typeProduit } = this.$route.params;
      const output = [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.getTitle, route: { name: 'l.bodac.catalogue-produitsModulePresse', params: { typeProduit } }, isActive: true },
      ];
      return output;
    },
    routeToCreation() {
      return {
        name: produitConf.PRODUITS_PRESSE_INFOS[this.$route.params.typeProduit].routeCreation,
      };
    },
    iconSelectTotal() {
      if (this.selectAllValue) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'actif'];
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      nbCritere += this.criteresRecherche.actif !== null ? 1 : 0;
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    baseTradArchiveComputed() {
      return function baseTrad(aArchiver) {
        if (aArchiver) return 'catalogue.archivage';
        return 'catalogue.desarchivage';
      };
    },
    columns() {
      const columns = [
        'selected', 'reference', 'type', 'typeSupport', 'libelle', 'agence', 'societe',
        'marche', 'fournisseur', 'dateDebut', 'dateFin', 'regroupementProduit',
        'actif', 'edit', 'archiver', 'delete',
      ];
      if (this.user.agences.length <= 1) columnsSplice(columns, 'agence');
      if (this.societesInformations.length === 1
        || this.filtrerProduitParSociete
        || this.filtrerProduitParAgence) {
        columnsSplice(columns, 'societe');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: tableConfig.SORT_ICON,
        headings: {
          reference: this.$t('listeProduitsModulePresse.tab.reference'),
          type: this.$t('listeProduitsModulePresse.tab.type'),
          typeSupport: this.$t('listeProduitsModulePresse.tab.typeSupport'),
          libelle: this.$t('listeProduitsModulePresse.tab.label'),
          marche: this.$t('listeProduitsModulePresse.tab.marche'),
          fournisseur: this.$t('listeProduitsModulePresse.tab.fournisseur'),
          societe: this.$t('listeProduitsModulePresse.tab.societe'),
          agence: this.$t('listeProduitsModulePresse.tab.agence'),
          actif: this.$t('listeProduitsModulePresse.tab.actif'),
          regroupementProduit: this.$i18n.t('listeProduitFace.tabs.regroupementProduit'),
          dateDebut: this.$t('listeProduitsModulePresse.tab.dateDebut'),
          dateFin: this.$t('listeProduitsModulePresse.tab.dateFin'),
          edit: '',
          delete: '',
          archiver: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: tableConfig.TEXTS,
        sortable: ['reference', 'libelle', 'type', 'actif'],
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          actif: 'colonneWidth130px',
        },
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          if (this.user.agences.length === 1) {
            data.query.agencesId = [this.user.agences[0].agenceId];
          }
          data.typeProduit = this.$route.params.typeProduit;
          return this.actionsLoadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduits,
          };
        }),
      };
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    exportExcelQuery() {
      const filtres = this.$route.params.typeProduit === produitConf.CATEGORIE_SPONSORING
        ? produitSponsoringTransform(this.lastPayload)
        : transform(this.lastPayload);
      return {
        typeDonnee: produitConf.EXPORT_EXCEL_PRODUIT_PRESSE,
        typeExport: '',
        filtres: filtres,
        parametresAdditionnels: {
          categorieVente: this.$route.params.typeProduit,
        },
        nomFichier: `Produits_${this.$route.params.typeProduit}`,
      };
    },
    referenceTable() {
      switch (this.$route.params.typeProduit) {
        case produitConf.CATEGORIE_AUTRE:
          return REFERENCE_TABLE_PRODUIT_AUTRE;
        case produitConf.CATEGORIE_SALON:
          return REFERENCE_TABLE_PRODUIT_SALON;
        case produitConf.CATEGORIE_SPONSORING:
          return REFERENCE_TABLE_PRODUIT_SPONSORING;
        case produitConf.CATEGORIE_PRESSE:
          return REFERENCE_TABLE_PRODUIT_PRESSE;
        default:
          return '';
      }
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...ProduitsPresse.mapActions({
      actionsLoadProduits: 'loadItems',
    }),
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    inProgress() {
      inProgress(this.$i18n);
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    selectionProduits() {
      this.produitSelectionne = this.produits
        .filter(el => el.selected).length > 0;
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.produits.forEach((el) => {
        el.selected = this.selectAllValue;
      });
      this.produitSelectionne = this.selectAllValue;
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeProduit.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    showPopUpArchivage(produitToArchive) {
      this.popUpArchivage = true;
      this.produitToArchive = produitToArchive;
    },
    async archiverProduit(status) {
      this.popUpArchivage = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        switch (this.produitToArchive.supportCommercial.categorieVente) {
          case produitConf.CATEGORIE_AUTRE:
            await archiverProduitAutre(this.produitToArchive.id, status);
            messageSucces(this.$t(this.baseTradArchiveComputed(status) + '.produitAutreArchiver'));
            break;
          case produitConf.CATEGORIE_SALON:
            await archiverProduitSalon(this.produitToArchive.id, status);
            messageSucces(this.$t(this.baseTradArchiveComputed(status) + '.produitSalonArchiver'));
            break;
          case produitConf.CATEGORIE_SPONSORING:
            await archiverProduitSponsoring(this.produitToArchive.id, status);
            messageSucces(this.$t(this.baseTradArchiveComputed(status) + '.produitSponsoringArchiver'));
            break;
          case produitConf.CATEGORIE_PRESSE:
            await archiverProduitPresse(this.produitToArchive.id, status);
            messageSucces(this.$t(this.baseTradArchiveComputed(status) + '.produitPresseArchiver'));
            break;
          default:
            this.inProgress();
            break;
        }
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeProduit.initializeFiltre();
      this.$refs.filtreListeProduit.viderCritere();
      this.$refs.filtreListeProduit.appliquerCritere();
      this.showFiltre = false;
    },
    isNotModifiableIntoHolding(produit) {
      return siteHasHolding() && (((produit.supportCommercial.societeId !== getIdSocieteHolding()
            || produit.supportCommercial.societeId !== this.societeActiveId)
          && (produit.supportCommercial.categorieVente === produitConf.CATEGORIE_LOCATION
            || produit.supportCommercial.categorieVente === produitConf.CATEGORIE_DIVERS)))
        || (produit.supportCommercial.societeId !== this.societeActiveId
          && produit.supportCommercial.categorieVente !== produitConf.CATEGORIE_LOCATION
          && produit.supportCommercial.categorieVente !== produitConf.CATEGORIE_DIVERS);
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    getLibelleAndRoutesForProduct(produit) {
      const produitConfig = produitConf.CATEGORIE_PRODUIT
        .find((p) => p.code === produit.supportCommercial.categorieVente);
      if (!produitConfig) return '';
      if (produitConfig.code !== produitConf.CATEGORIE_LOCATION) return produitConfig;
      return produit.numerique ? produitConfig.numerique : produitConfig.nonNumerique;
    },
    getLibelleActif(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((s) => s.id === societeId);
      return societe?.libelle || null;
    },
    getAgenceLibelle(agenceId) {
      let libelleAgence = '';
      this.societesInformations.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.id === agenceId) libelleAgence = agence.libelle;
        });
      });
      return libelleAgence;
    },
    getFournisseurs(marche) {
      if (!marche?.commissions?.length) return [];
      return marche.commissions
        .map(el => el.fournisseur);
    },
    getDate(date) {
      return formatDate(date);
    },
    updateAgenceAndRecherche() {
      if (this.filtrerProduitParAgence) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.recherche();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.setInformationPage(this.$t('pageGescom.produit.listeProduitPresse'));
    try {
      await this.loadSocietes({});
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
      ]);
      if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      }
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
